import defaultRouter from "./defaultRouter";
import teaRouter from "@/tea/router";
import domain from "@/utils/appDomain";

const router = domain.isTea ? teaRouter: defaultRouter;
export default router;